// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* WARNING: This section must be updated if _variables.ts is changed */
/* PERCENTAGE COLOURS */
.avatar {
  width: 42px;
  height: 42px;
  margin-left: 14px;
}

.unread-alerts {
  border-radius: 10px;
  font-weight: 500;
  color: white;
  background-color: #dc3545;
}

.cleared-alerts {
  border-radius: 10px;
  color: white;
  background-color: #078BCB;
}

.custom-dropdown-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 0;
}

.custom-dropdown-menu {
  border-radius: 8px;
  margin-top: 5px;
  padding-top: 0;
  padding-right: 10px;
  padding-left: 10px;
  width: 250px;
  border: 1px solid rgba(211, 211, 211, 0.75);
  box-shadow: 0 0.5rem 1rem rgba(35, 31, 32, 0.15) !important;
}

.greeting-message {
  padding: 10px 10px 0 10px;
  font-size: 14px;
  font-weight: 700;
}

.comment-icon {
  position: relative;
  width: 2rem;
  height: 2rem;
  background-color: transparent;
  border-radius: 0.5rem;
  padding: 0.25rem;
  margin-left: 0.5rem;
  cursor: pointer;
}
.comment-icon .badge {
  position: absolute;
  top: 0;
  right: 0;
  background-color: #078BCB;
  color: white;
  border-radius: 50%;
  padding: 2px 5px;
  font-size: 10px;
}
.comment-icon:hover {
  background-color: rgba(211, 211, 211, 0.4);
}
.comment-icon:hover svg {
  color: #414448;
}
.comment-icon svg {
  color: gray;
}
.comment-icon .unread-alerts {
  border-radius: 10px;
  font-weight: 500;
  color: white;
  background-color: #dc3545;
}
.comment-icon .cleared-alerts {
  border-radius: 10px;
  color: white;
  background-color: #078BCB;
}

.menu-badge {
  border-radius: 50%;
  padding: 2px 5px;
  font-size: 10px;
}`, "",{"version":3,"sources":["webpack://./src/white-labelling/default/_variables.scss","webpack://./src/app/core/components/shifts-navigation-container/shifts-navigation-menu/shifts-navigation-menu.component.scss"],"names":[],"mappings":"AAiDA,sEAAA;AAYA,uBAAA;AC3DA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AACF;;AAEA;EACE,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,yBAAA;AACF;;AAEA;EACE,mBAAA;EACA,YAAA;EACA,yBDhBQ;ACiBV;;AAEA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;AACF;;AAEA;EACE,kBAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,2CAAA;EACA,2DAAA;AACF;;AAEA;EACE,yBAAA;EACA,eAAA;EACA,gBAAA;AACF;;AAEA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,6BAAA;EACA,qBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;AACF;AACE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,yBDzDM;EC0DN,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;AACJ;AAEE;EACE,0CAAA;AAAJ;AAEI;EACE,cDlDS;ACkDf;AAIE;EACE,WAAA;AAFJ;AAKE;EACE,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,yBAAA;AAHJ;AAME;EACE,mBAAA;EACA,YAAA;EACA,yBDtFM;ACkFV;;AAQA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;AALF","sourcesContent":["// Core theme colors\n$primary0: #0EABF7;\n$primary: #078BCB;\n$primary2: #067ab2;\n$primary3: #05699a;\n$selectedBackground: #ebf5ff;\n\n// Colour variables\n$black: #000000;\n$border-colour: #dee2e6;\n$card-border: #dfdfdf;\n$cardBorderGrey: #d9dee8;\n$disabled: #caced5;\n$disabledButtonColor: #7bb3d0;\n$disabled-background: #ececec;\n$form-error: #f84646;\n$highlight: #f5f5f5;\n$hoverHighlight: rgba(35, 31, 32, 0.31);\n$inactive: rgba(255, 0, 0, 0.1);\n$inactiveHighlight: rgba(255, 0, 0, 0.2);\n$kaliber-dark: #414448;\n$link: #2185d0;\n$placeholder: #aab2c0;\n$selectedButton: #002865;\n$subtitle: #a0a2a4;\n$white: #ffffff;\n$cardBorderGrey: #d9dee8;\n\n// Bootstrap Colours\n$secondary: #222222;\n$dark: #7a7a7a;\n$background-light: #efefef;\n$print-page-size: auto;\n\n$danger: #d9534f;\n$muted: #85959f;\n$text-muted: #85959f;\n$success: #61f2b6;\n$warning: #f0ad4e;\n$info: #5bc0de;\n$light: #f8f9fa;\n$light-gray: #d3d3d3;\n$background-dark: #414448;\n$disabled-background: rgba(221, 221, 221, 0.3) !default;\n\n// Common Styles\n$border: 1px solid $border-colour;\n$appComsHeight: 60px;\n\n/* WARNING: This section must be updated if _variables.ts is changed */\n$target: #fcb800;\n$declined: #d11f4b;\n$active: #f77f21;\n$quoteReady: #d299c4;\n$quoteApproved: #7c4795;\n$submitted: #662066;\n$won: #3e9937;\n$lost: #00245e;\n$live: #00b0f0;\n$completed: #a9d18e;\n\n/* PERCENTAGE COLOURS */\n$percentage-green: #15b422;\n$percentage-light-green: #a3d000;\n$percentage-yellow: #fcb000;\n$percentage-red: #ff0000;\n\n// DO NOT USE IF YOU SEE THESE BEING USED. PLEASE REMOVE\n$exportTableHeight: 530px;\n$footerHeight: 60px;\n$height650px: 650px;\n$headerNavHeight: 60px;\n$headerHeight: 42px;\n$inputPercentWidth: 91px;\n$inputDiscountWidth: 126px;\n$exportTableHeight: 530px;\n$incExcTableHeight: 300px;\n$sidebarMenuWidth: 120px;\n$sideNavWidth: 67px;\n$height650px: 650px;\n$headerNavHeight: 60px;\n\n// Image References\n$loginLogo: './assets';\n","@import 'variables';\n\n.avatar {\n  width: 42px;\n  height: 42px;\n  margin-left: 14px;\n}\n\n.unread-alerts {\n  border-radius: 10px;\n  font-weight: 500;\n  color: white;\n  background-color: #dc3545;\n}\n\n.cleared-alerts {\n  border-radius: 10px;\n  color: white;\n  background-color: $primary;\n}\n\n.custom-dropdown-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border: 0;\n}\n\n.custom-dropdown-menu {\n  border-radius: 8px;\n  margin-top: 5px;\n  padding-top: 0;\n  padding-right: 10px;\n  padding-left: 10px;\n  width: 250px;\n  border: 1px solid rgba(211, 211, 211, 0.75);\n  box-shadow: 0 0.5rem 1rem rgba(35, 31, 32, 0.15) !important;\n}\n\n.greeting-message {\n  padding: 10px 10px 0 10px;\n  font-size: 14px;\n  font-weight: 700;\n}\n\n.comment-icon {\n  position: relative;\n  width: 2rem;\n  height: 2rem;\n  background-color: transparent;\n  border-radius: 0.5rem;\n  padding: 0.25rem;\n  margin-left: 0.5rem;\n  cursor: pointer;\n\n  .badge {\n    position: absolute;\n    top: 0;\n    right: 0;\n    background-color: $primary;\n    color: white;\n    border-radius: 50%;\n    padding: 2px 5px;\n    font-size: 10px;\n  }\n\n  &:hover {\n    background-color: rgba(lightgray, 0.4);\n\n    svg {\n      color: $kaliber-dark;\n    }\n  }\n\n  svg {\n    color: gray;\n  }\n\n  .unread-alerts {\n    border-radius: 10px;\n    font-weight: 500;\n    color: white;\n    background-color: #dc3545;\n  }\n\n  .cleared-alerts {\n    border-radius: 10px;\n    color: white;\n    background-color: $primary;\n  }\n}\n\n.menu-badge {\n  border-radius: 50%;\n  padding: 2px 5px;\n  font-size: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
